import { styled } from '../styled';

const Row = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 6,
});

const Chip = styled('button', { shouldForwardProp: p => p !== '$active' })(({ $active }) => ({
  appearance: 'none',
  border: `1px solid ${$active ? 'var(--qhs-brand)' : 'var(--qhs-border)'}`,
  background: $active ? 'var(--qhs-brand-tint-12)' : 'var(--qhs-surface)',
  color: $active ? 'var(--qhs-brand)' : 'var(--qhs-text-2)',
  fontSize: 12,
  fontWeight: $active ? 600 : 500,
  padding: '6px 10px',
  borderRadius: 999,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  transition: 'all 140ms ease',
  '& .count': {
    fontSize: 10,
    fontFamily: "'Source Code Pro', 'JetBrains Mono', monospace",
    fontWeight: 700,
    background: $active ? 'var(--qhs-brand)' : 'var(--qhs-bg, #f5f7fa)',
    color: $active ? '#fff' : 'var(--qhs-text-3)',
    padding: '1px 5px',
    borderRadius: 999,
  },
  '&:hover': {
    borderColor: 'var(--qhs-brand)',
    color: 'var(--qhs-brand)',
  },
}));

const CatalogChipRow = ({ chips, activeId, onSelect }) => (
  <Row>
    {chips.map(chip => (
      <Chip
        key={chip.id}
        type="button"
        $active={chip.id === activeId}
        onClick={() => onSelect(chip.id)}
      >
        {chip.label}
        <span className="count">{chip.count}</span>
      </Chip>
    ))}
  </Row>
);

export default CatalogChipRow;
